const initState = {
  rvRatings: [],
};

const rvRatingReducer = (state = initState, action) => {
  switch (action.type) {
    case "GET_RV_RATINGS":
      return {
        ...state,
        rvRatings: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
};

export default rvRatingReducer;
